// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_VincularComboInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/vincular_combo/{item_id}
 *
 * Cobre um item de servico da OS com uma compra de combo pre-pago do cliente
 * (NS 2026-0090, feature `combos`): reserva 1 par e zera o preco do item.
 *
 * JSON body:
 * {
 *   "combo_purchase_id": 12   // so_combo_purchases PK, required
 * }
 */
import { registerContract } from './validate'

export interface Orders_VincularComboInput {
combo_purchase_id: number
}

registerContract('Orders_VincularComboInput', {
  combo_purchase_id: { type: 'number',  required: true },
})
